<template>
  <div class="h-input" testek="textarea">
    <div v-if="title" class="dq-mgb-5 text-title">
      {{ title }}
    </div>
    <textarea
      style="width: 100%"
      :style="{ height: height + 'px' }"
      class="input"
      :class="inputClass"
      type="text"
      v-bind="$attrs"
      @input="handleInput"
      :maxlength="maxLength"
    ></textarea>
  </div>
</template>

<script>
export default {
  name: "HTextarea",
  props: {
    title: {
      default: "",
      typeof: String,
    },
    height: {
      default: 100,
      typeof: Number,
    },
    inputClass: {
      default: "",
      typeof: String,
    },
    maxLength: {
      default: 500,
      typeof: Number,
    },
  },
  data() {
    return {};
  },
  methods: {
    handleInput(event) {
      this.$emit("input", event.target.value);
    },
  },
};
</script>
<style lang="scss" scoped>
.h-input {
  box-sizing: border-box;
}
.input {
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  padding-left: 10px;
  outline: none !important;
}
.text-title {
  font-weight: bold;
}
</style>
